import { Dayjs } from "dayjs";
import { OfflineDays, ServiceAvailabilityException, Service } from "types/entities";
import {
	checkDisabledDate,
	filterServicesByAnticipation,
	filterServicesByDateBetweenStartDateAndEndDate,
	filterServicesByDayOfWeek,
} from "./filter";

// This function evaluates each day in the date picker. If it returns true, the day is disabled;
// if it returns false, the day is enabled.

// This is for the flow where we need to filter based on available services.
export const disableDate = (
	services: Service[],
	offlineDays: OfflineDays[],
	offlineDaysByServices: { date: Date; service: Service }[],
	serviceAvailabilityException: ServiceAvailabilityException[]
) => {
	const shouldDisableDate = (day: Dayjs) => {
		//If the current day is before today, disable it
		const today = new Date();
		today.setHours(0, 0, 0, 0);
		const dayDate = day.toDate();
		dayDate.setHours(0, 0, 0, 0);
		if (dayDate.getTime() < today.getTime()) return true;

		//If the current day is offline, then disable it
		if (
			offlineDays.find(
				(offlineDay) => offlineDay.date.getTime() === dayDate.getTime()
			)
		)
		return true;
		
		// Check services that belong to this day. If the filtered result is an empty array,
		// disable this day.
		let filteredServices = filterServicesByDateBetweenStartDateAndEndDate(services, day.toDate());
		if (filteredServices.length === 0) return true;

		filteredServices = filterServicesByDayOfWeek(services, day.toDate());
		if (filteredServices.length === 0) return true;
		
		// Filter services by anticipation (presumably based on lead time requirements).
		filteredServices = filterServicesByAnticipation(
			filteredServices,
			day.toDate()
		);
		if (filteredServices.length === 0) return true;
		
		// Check if the day is disabled by all services being in the day's exception,
		// by all shifts of all services being disabled or by a combination of both cases.
		const isDisabled = checkDisabledDate(
			dayDate,
			filteredServices,
			serviceAvailabilityException,
			offlineDaysByServices
		);
		
		if (isDisabled) return true;

		return false;
	};

	return shouldDisableDate;
};
